module.exports = __webpack_public_path__ + "f9fce0da492dca55734e4130ffa05896.svg";